import React from 'react'
import { connect } from 'react-redux'
import ToastItem from './ToastItem'
import { selectors } from '../../redux/toastNotifications'
import { dismissToast } from '../../redux/actions/toastNotifications'
import './styles.css'

function ToastNotifications({ toasts = [], dismiss }) {

  const items = [...toasts].slice(-5).reverse()
  return (
    <div className="toast-container" aria-live="polite" aria-atomic="true">
      {items.map(t => (
        <ToastItem key={ t.id } toast={ t } onClose={ dismiss } />
      ))}
    </div>
  )
}

const mapState = state => ({ toasts: selectors.all(state) }),
mapDispatch = { dismiss: dismissToast }

export default connect(mapState, mapDispatch)(ToastNotifications)



// WEBPACK FOOTER //
// ./src/components/Notifications/ToastNotifications.js